"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaStatus = void 0;
var AlgoliaStatus;
(function (AlgoliaStatus) {
    AlgoliaStatus["IDLE"] = "IDLE";
    AlgoliaStatus["LOADING"] = "LOADING";
    AlgoliaStatus["ERROR"] = "ERROR";
})(AlgoliaStatus = exports.AlgoliaStatus || (exports.AlgoliaStatus = {}));
//# sourceMappingURL=algoliaStatus.js.map